import { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { TabsUI, FormLabelUI, FormErrorUI, InputUI, FileTabUI, DeleteDialogUI } from '../Interface';
import TaskReportsTable from './TaskReportsTable';
import SimpletaskResponsiblePerson from './SimpletaskResponsiblePerson';

import { v4 as uuidv4 } from 'uuid';
import ResourcesTable from './ResourcesTable';
import DynamicPropertyMain from '../DynamicProperty/DynamicPropertyMain';
import ExcelImportTab from '../Interface/ExcelImportTab';
import useParam from '../../context/ParamContext';

const DescriptionPanel = (props) => {
  const { params, getParam } = useParam();

  useEffect(() => {
    if (Object.keys(params).length === 0) getParam();
  }, []);

  const { disabled } = props;
  const { values, errors } = useFormikContext();
  return (
    <div>
      <div className="col-span-full relative">
        <div>
          <Field
            type="text"
            name="simpleTaskDescription"
            as={InputUI}
            className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text={params?.SIMPLETASK_DESCRIPTION_LABEL ?? 'Leírás'} />}
            variant="standard"
            helperText={<FormErrorUI message={errors.simpleTaskDescription} />}
            disabled={disabled}
            InputLabelProps={{ shrink: values.simpleTaskDescription !== '' }}
            multiline
            rows={4}
          />
        </div>
        {params.HIDE_SIMPLETASK_SOLUTION_PROPOSAL !== 'Y' && (
          <div className="mt-2">
            <Field
              type="text"
              name="solutionProposal"
              as={InputUI}
              className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
              fullWidth
              label={<FormLabelUI text={params?.SIMPLETASK_SOLUTION_PROPOSAL_LABEL ?? 'Válasz'} />}
              variant="standard"
              helperText={<FormErrorUI message={errors.solutionProposal} />}
              disabled={disabled}
              InputLabelProps={{ shrink: values.solutionProposal && values.solutionProposal !== '' }}
              multiline
              rows={4}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const SimpleTaskTabs = (props) => {
  const { setFieldValue, values } = useFormikContext();
  const { selectedValues, disabled } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const { params, getParam } = useParam();

  useEffect(() => {
    if (Object.keys(params).length === 0) getParam();
  }, []);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.simpleTaskAttachment) ? values.simpleTaskAttachment : [];

    setFieldValue('simpleTaskAttachment', [...existingAttachments, ...filesWithId]);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'simpleTaskAttachment',
      (values.simpleTaskAttachment || []).filter((simpleTaskAttachment) => simpleTaskAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 0,
      name: 'Leírás',
      content: <DescriptionPanel {...props} />,
    },
    ...(params?.HIDE_SIMPLETASK_PROPERTY_TAB !== 'Y'
      ? [
          {
            id: 1,
            name: 'Tulajdonságok',
            content: <DynamicPropertyMain {...props} />,
          },
        ]
      : []),
    ...(!selectedValues.parentId && params.HIDE_SIMPLETASK_RESOURCES_TAB !== 'Y'
      ? [
          {
            id: 5,
            name: 'Erőforrásigény',
            content: <ResourcesTable {...props} />,
          },
        ]
      : []),
    {
      id: 2,
      name: 'Dokumentumok',
      content: (
        <FileTabUI
          savedFiles={values?.simpleTaskAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          disabled={disabled}
          handleUpload={handleUpload}
        />
      ),
    },

    ...(params?.HIDE_SIMPLETASK_RESPONSIBLE_PERSON_TAB !== 'Y'
      ? [
          {
            id: 3,
            name: 'További felelősök',
            content: <SimpletaskResponsiblePerson {...props} />,
          },
        ]
      : []),

    ...(params?.HIDE_SIMPLETASK_REPORTS_TAB !== 'Y'
      ? [
          {
            id: 4,
            name: 'Lejelentések',
            content: <></>,
            content: (
              <TaskReportsTable
                simpleTaskId={selectedValues?.simpleTaskId}
                reportList={selectedValues?.taskReports ?? []}
              />
            ),
          },
        ]
      : []),
    // az 5 id foglalt, csak a sorrend miatt fel kellett rakni 3. helyre (délvill)
    ...(params?.HIDE_EXCEL_IMPORT_TAB !== 'Y'
      ? [
          {
            id: 6,
            name: 'Adat import',
            content: <ExcelImportTab {...props} />,
          },
        ]
      : []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default SimpleTaskTabs;
